import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { componentElDefaults, componentElPropTypes } from '../customPropTypes/componentEl';
import { addClassNames, classNamePropTypes } from '../customPropTypes/classNames';
import { breakpoints, cols } from './utils';
import { addBorderClasses, borderPropTypes } from '../customPropTypes/border';

/*
column for grid
*/
import { jsx as _jsx } from "react/jsx-runtime";
function Col(_ref) {
  var Component = _ref.componentEl,
    className = _ref.className,
    children = _ref.children,
    xs = _ref.xs,
    sm = _ref.sm,
    md = _ref.md,
    lg = _ref.lg,
    xsOffset = _ref.xsOffset,
    smOffset = _ref.smOffset,
    mdOffset = _ref.mdOffset,
    lgOffset = _ref.lgOffset,
    last = _ref.last,
    first = _ref.first,
    border = _ref.border,
    style = _ref.style;
  var cssClasses = ['st_col'];
  var additionalAttrs = {
    style: style
  };
  cssClasses = addClassNames(className, cssClasses);
  if (xs && xs !== true) cssClasses.push("st_col-xs-".concat(xs));
  if (xs === true) cssClasses.push('st_col-xs');
  if (sm && sm !== true) cssClasses.push("st_col-sm-".concat(sm));
  if (sm === true) cssClasses.push('st_col-sm');
  if (md && md !== true) cssClasses.push("st_col-md-".concat(md));
  if (md === true) cssClasses.push('st_col-md');
  if (lg && lg !== true) cssClasses.push("st_col-lg-".concat(lg));
  if (lg === true) cssClasses.push('st_col-lg');
  if (xsOffset) cssClasses.push("st_col-xs-offset-".concat(xsOffset));
  if (smOffset) cssClasses.push("st_col-sm-offset-".concat(smOffset));
  if (mdOffset) cssClasses.push("st_col-md-offset-".concat(mdOffset));
  if (lgOffset) cssClasses.push("st_col-lg-offset-".concat(lgOffset));
  if (last) cssClasses.push("st_last-".concat(last));
  if (first) cssClasses.push("st_first-".concat(first));
  cssClasses = addBorderClasses(border, cssClasses);
  if (border) {
    if (!additionalAttrs.style) additionalAttrs.style = {};
    if (border.left) {
      additionalAttrs.style['--st-grid-border-l'] = 'var(--st-border-width)';
    }
    if (border.right) {
      additionalAttrs.style['--st-grid-border-r'] = 'var(--st-border-width)';
    }
  }
  return /*#__PURE__*/_jsx(Component, _extends({
    className: cssClasses.join(' ')
  }, additionalAttrs, {
    children: children
  }));
}

/*
between
around
bottom
middle
top
center
start
end

xs sm md lg
*/

process.env.NODE_ENV !== "production" ? Col.propTypes = {
  /** dom element or component to use for outermost wrapper */
  componentEl: componentElPropTypes,
  /** extra CSS classes, if any */
  className: classNamePropTypes,
  /* size at XS breakpoint */
  xs: PropTypes.oneOf([true].concat(_toConsumableArray(cols))),
  /* size at SM breakpoint */
  sm: PropTypes.oneOf([true].concat(_toConsumableArray(cols))),
  /* size at MD breakpoint */
  md: PropTypes.oneOf([true].concat(_toConsumableArray(cols))),
  /* size at LG breakpoint */
  lg: PropTypes.oneOf([true].concat(_toConsumableArray(cols))),
  /* offset at XS breakpoint */
  xsOffset: PropTypes.oneOf(cols),
  /* offset at SM breakpoint */
  smOffset: PropTypes.oneOf(cols),
  /* offset at MD breakpoint */
  mdOffset: PropTypes.oneOf(cols),
  /* offset at LG breakpoint */
  lgOffset: PropTypes.oneOf(cols),
  /* move item to be last */
  last: PropTypes.oneOf(breakpoints),
  /* move item to be first */
  first: PropTypes.oneOf(breakpoints),
  /** whether column should show a border to the left or right */
  border: borderPropTypes
} : void 0;
Col.defaultProps = {
  componentEl: componentElDefaults,
  className: null,
  xs: null,
  sm: null,
  md: null,
  lg: null,
  xsOffset: null,
  smOffset: null,
  mdOffset: null,
  lgOffset: null,
  last: null,
  first: null,
  border: null
};
export default Col;